import Swal from "sweetalert2";
import moment from "moment";
import Add from "./Add/Add.vue";

export default {
  name: "AddUser",
  created() {
      this.GetMadisons();
      this.GetAllCompanies();
  },
  components: {
    Add: Add,
  },
  filters: {
    moment: function(date) {
      if (date === null) {
        return "فارغ";
      }
      // return moment(date).format('MMMM Do YYYY, h:mm:ss a');
      return moment(date).format("MMMM Do YYYY");
    },
  },
  data() {
    return {
      pageNo: 1,
      pageSize: 10,
      pages: 0,
      state: 0,
        Madisons: [],
        companies: [],
      SelectedItem: "",
      ruleForm: {
        Id: null,
          Code: "",
          ProprietaryName: "",
          ChemicalName: "",
          OperationalNumber: "",
          Unit:"",
      },
      rules: {
      //  Name: this.$helper.ArabicOnly(),
    //    CompanyId: this.$helper.Required(),
      },
    };
  },
  methods: {
    edit(item) {
      this.ruleForm.Id = item.id;
          this.ruleForm.ProprietaryName = item.proprietaryName;
          this.ruleForm.ChemicalName = item.chemicalName;
          this.ruleForm.Code = item.code;
          this.ruleForm.OperationalNumber = item.operationalNumber;
      document.getElementById("open").click();
    },

    submitForm(formName) {
      if (this.$helper.submitForm(this.$refs[formName])) {
        if (this.ruleForm.Id) {
          return this.update(formName);
        }
        this.Add(formName);
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
      update(formName) {
          debugger
      this.$blockUI.Start();
      this.$http
          .UpDateMadison(this.ruleForm)
        .then(() => {
          this.$blockUI.Stop();
          Swal.fire({
            icon: "success",
            title: "تم الحفظ بنجاح",
            showCancelButton: false,
          }).then(() => {});
            this.GetMadisons();
          document.getElementById("close").click();
          this.resetForm(formName);
          this.ruleForm.Id = null;
        })
        .catch(() => {
          this.$blockUI.Stop();
        });
    },
    Add(formName) {
      this.$blockUI.Start();
      this.$http
          .AddMadisons(this.ruleForm)
        .then(() => {
          this.$blockUI.Stop();
          Swal.fire({
            icon: "success",
            title: "تم الحفظ بنجاح",
            showCancelButton: false,
          }).then(() => {});
            this.GetMadisons();
          document.getElementById("close").click();
          this.resetForm(formName);
          this.ruleForm.Id = null;
        })
        .catch(() => {
          this.$blockUI.Stop();
        });
    },
    AddItemPage() {
      this.state = 1;
    },

      GetAllCompanies() {
          this.$blockUI.Start();
          this.$http
              .GetAllCompanies()
              .then((response) => {
                  this.$blockUI.Stop();
                  this.companies = response.data.info;
              })
              .catch(() => {
                  this.$blockUI.Stop();
              });
      },
      GetMadisons(pageNo) {
      this.pageNo = pageNo;
      if (this.pageNo === undefined) {
        this.pageNo = 1;
      }
      this.$blockUI.Start();
      this.$http
          .GetMadisons(this.pageNo, this.pageSize)
        .then((response) => {
          this.$blockUI.Stop();
            this.Madisons = response.data.info;
          this.pages = response.data.count;
        })
        .catch(() => {
          this.$blockUI.Stop();
        });
    },

    deleteItem(id) {
      Swal.fire({
        title: "هـل انت متأكد من عملية الحذف ؟",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: `تأكيد العملية`,
        denyButtonText: `الغاء العملية`,
      }).then((result) => {
        if (result.isConfirmed) {
          this.$blockUI.Start();
          this.$http
              .deleteMadisons(id)
            .then((response) => {
              this.$blockUI.Stop();
              this.FormPorgress = 100;
              Swal.fire({
                icon: "success",
                title: "..نجـاح العملية",
                html: response.data,
                showCancelButton: false,
              }).then(() => {
                this.$blockUI.Stop();
                  this.GetMadisons();
              });
            })
            .catch((err) => {
              this.$blockUI.Stop();

              this.$helper.showWorning(err.response.data);
            });
          return;
        }
      });
    },

    // CheckLoginStatus() {
    //     try {
    //         this.loginDetails = JSON.parse(localStorage.getItem('currentUser-client'));
    //         if (this.loginDetails == null) {
    //             window.location.href = '/Login';
    //         }
    //     } catch (error) {
    //         window.location.href = '/Login';
    //     }
    // },
  },
};
